export interface RedirectConfig {
  defaultRedirectPath?: string;
  adminRedirectPath?: string;
}

/**
 * Determine the redirect path after login based on role and config.
 * Explicit redirectUrl (from query param) always takes priority.
 */
export function getRedirectPath(
  redirectUrl: string | null,
  isAdmin: boolean | undefined,
  config: RedirectConfig,
): string {
  if (redirectUrl) return redirectUrl;
  if (isAdmin) return config.adminRedirectPath || "/dashboard";
  return config.defaultRedirectPath || "/profile";
}
